import { createSvgIcon } from '@mui/material';

const IconArrowDownward = createSvgIcon(
  <path d="M11 4V16.175L5.4 10.575L4 12L12 20L20 12L18.6 10.575L13 16.175V4H11Z" />,
  'arrow_downward'
);

export default IconArrowDownward;
